module.exports = __webpack_public_path__ + "static/media/UpDownEnabled.1aaee64e.svg";